import React from "react";
import { Room } from "@uno/protocol";
import { useNavigate } from "react-router-dom";

const useJoinRoom = () => {
    const navigate = useNavigate();

    return React.useCallback((room: Room) => navigate(`/room/${room.id}`), [navigate]);
};

export default useJoinRoom;
